export const texts = {
  reviewJobsiteCta: {
    de: 'Jetzt freigeben',
    en: 'Approve now'
  },
  reviewJobsite: {
    de: 'Bitte geben Sie die Jobsite frei',
    en: 'Please approve the jobsite'
  },
  feedbackJobsiteCta: {
    de: 'Jetzt feedbacken',
    en: 'Give feedback now'
  },
  feedbackJobsite: {
    de: 'Bitte gib Feedback zur Jobsite',
    en: 'Please give feedback on the jobsite'
  }
};
